<div class="div__mensagens">
  <div class="div__mensagem__individual">
    <div class="imagem__usuario">
      <!-- TODO: aqui será exibida a foto de perfil do usuário que está logado enviando a mensagem -->
      <img src="/assets/images/simbolos/fotoPerfil.png"
            alt="icone"
            class="imagem__mensagem">
    </div>
    <div class="div__nome__mensagem">
      <p>
        <span>{{ usuario }}</span><br />
        {{ mensagemUsuario }}
      </p>
      <img
        *ngIf="showOrHideImage"
        alt="imagem inserida pelo usuário na mensagem"
        src={{imagemInserida}} class="imagem__inserida">
    </div>
  </div>
</div>
